import { Map } from 'immutable';

import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

export function productionPartners({ channel, preview }) {
  return {
    payload: Map({
      type: OPERATIONS[channel].PRODUCTION_PARTNERS,
      value: preview.get(ATTRIBUTE.PRODUCTION_PARTNERS),
    }),
  };
}
